let columnsJson = [
    {prop:'task_id',filterMultiple:true,label:'任务ID',fixed:'left',width:'80',resizable: true},
    {prop:'month',filterMultiple:false,label:'所属月份',fixed:'left',width:'80',resizable: true},
    {prop:'order_id',filterMultiple:true,label:'后台订单ID',width:'80',resizable: true},
    {prop:'company',filters:[],filterMultiple:true,label:'签约公司',fixed:'',width:'80',resizable: true},
    {prop:'salesman',filterMultiple:true,label:'销售人员',fixed:'',width:'80',resizable: true},
    {prop:'handler',filters:[],filterMultiple:true,label:'经手人',width:'80',resizable: true},
    {prop:'customer_name',filters:[],filterMultiple:true,label:'客户全称',fixed:'',width:'80',resizable: true},
    {prop:'project_name',filterMultiple:true,label:'项目名称',fixed:'',width:'80',resizable: true},
    {prop:'launch_start_date',filterMultiple:true,label:'投放起始日期',fixed:'',width:'100',resizable: true},
    {prop:'launch_end_date',filterMultiple:true,label:'投放截止日期',fixed:'',width:'100',resizable: true},
    {prop:'launch_platform',filterMultiple:true,label:'投放平台',fixed:'',width:'100',resizable: true},
    {prop:'media_name',filters:[],filterMultiple:true,label:'媒体名称',fixed:'',width:'100',resizable: true},
    {prop:'amount',filterMultiple:true,label:'订单金额',fixed:'',width:'100',resizable: true},
    {prop:'internet_celebrity_name',filters:[],filterMultiple:true,label:'网红名称',fixed:'',width:'100',resizable: true},
    {prop:'internet_celebrity_id',filterMultiple:true,label:'网红ID',fixed:'',width:'100',resizable: true},
    {prop:'offline_celeb_name',filterMultiple:true,label:'线下补款收款人姓名',fixed:'',width:'100',resizable: true},
    {prop:'offline_subsidy_company',filterMultiple:true,label:'线下付款公司',fixed:'',width:'100',resizable: true},
    {prop:'offline_subsidy_amount',filterMultiple:true,label:'线下补款金额',fixed:'',width:'100',resizable: true},
    {prop:'rebate',filterMultiple:true,label:'补款总额(含税)',fixed:'',width:'100',resizable: true},
    {prop:'offline_pay_date',filterMultiple:true,label:'线下付款日期',fixed:'',width:'100',resizable: true},

]
export default columnsJson


// WEBPACK FOOTER //
// ./src/components/Order/json/offline.js